export default "__VITE_ASSET__ISEZjkOj__"